<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import vConsole from 'vconsole'
export default {
  data() {
    return {
      isDebug: false,
      vConsole: undefined
    }
  },
  created() {
    const isDebug = process.env.VUE_APP_DEBUG
    this.isDebug = Boolean(Number(isDebug))
    if (this.isDebug) {
      // this.vConsole = new vConsole()
    }
  },
  beforeDestroy() {
    if (this.isDebug) {
      this.vConsole.destroy()
      this.vConsole = undefined
    }
  }
}
</script>

<style lang="less">
html body {
  font-family: PingFangSC-Regular, PingFang SC;
}
input {
  background-color: rgba(0, 0, 0, 0);
}
button {
  position: relative;
}
button::before {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  background-color: #000;
  border: inherit;
  border-color: #000;
  border-radius: inherit;
  transform: translate(-50%, -50%);
  opacity: 0;
  content: '';
}
button:active::before {
  opacity: 0.1;
}
textarea {
  resize: none;
}
body,
input,
textarea,
button {
  margin: 0;
  padding: 0;
  border: 0;
}
</style>
